var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "input-group",
        { attrs: { icon: "fa fa-calendar" } },
        [
          _c("v-select", {
            ref: "picker-component",
            staticClass: "form-control",
            attrs: {
              options: _vm.options,
              clearable: false,
              label: "label",
              "close-on-select": ""
            },
            model: {
              value: _vm.selectedOption,
              callback: function($$v) {
                _vm.selectedOption = $$v
              },
              expression: "selectedOption"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }